import { Dropdown } from 'antd';
import { compact } from 'lodash';
import React, { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect, useDispatch } from 'react-redux';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import { getRecurringTasksAction, openTaskAction } from '../../../../../redux/tasks/actions';
import { getOpenedTaskPriority, getOpenedTaskTitleIdentifier, isOpenedTaskRecurring } from '../../../../../redux/tasks/taskEntities/selectors';

const TaskDetailsRecurringTasks = ({ isModal, isRecurring, taskId, taskTitleIdentifier }) => {
  const dispatch = useDispatch();
  const [recurringTasks, setRecurringTasks] = useState([]);

  // useEffect(() => {
  //   if (isRecurring) {
  //     dispatch(
  //       getRecurringTasksAction(taskId, (res) => {
  //         setRecurringTasks(res);
  //       }),
  //     );
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isRecurring, taskId])

  const menuOptions = useMemo(() => ({
    items: compact(recurringTasks.map((val) => {
      if (val?.titleIdentifier === taskTitleIdentifier) {
        return undefined;
      }

      return {
        value: val?._id,
        label: (
          <div className={`d-flex p-1`}>
            <div className="font-14 truncate w-full">
              <span className="font-12">
                {val?.titleIdentifier}
              </span>{' '}
              | {val?.taskTitle}
            </div>
          </div>
        ),
        onClick: () => {
          dispatch(openTaskAction(true, val?.titleIdentifier, val?._id));
        },
      };
    })),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [recurringTasks, taskTitleIdentifier]);

  const colm1 = useMemo(() => isModal
    ? 'col-span-2 flex align-center'
    : 'col-span-3 flex align-center',
  [isModal]);

  return !isRecurring ? null : (
    <div className="flex items-center gap-2 py-1">
      {isRecurring && (
        <div className="flex items-center gap-2 shrink-0">
          <img
            src="/images/icons/down-right.svg"
            alt=""
            style={{
              height: '16px',
              width: '16px',
              marginRight: 10,
            }}
          />
          <div className="font-14">
            <FormattedMessage
              id="RECURRING_TASKS"
              defaultMessage="Recurring Tasks"
            />
          </div>
        </div>
      )}
      {isRecurring && (
        <div className="flex-1 min-w-0">
          <Dropdown menu={menuOptions} trigger={['click']}>
            <div className="btn-2 flex align-center justify-between">
              <div className="font-14 truncate mr-3">
                <FormattedMessage id="SELECT_TASK" defaultMessage="Select Task" />
              </div>
              <img src={'/images/icons/black-arrow-down.svg'} style={{ cursor: 'pointer', height: '10px', width: '10px' }} alt="icon" />
            </div>
          </Dropdown>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  isRecurring: isOpenedTaskRecurring(state),
  taskId: getOpenedTaskId(state),
  taskPriority: getOpenedTaskPriority(state),
  taskTitleIdentifier: getOpenedTaskTitleIdentifier(state),
});

export default connect(mapStateToProps)(TaskDetailsRecurringTasks);
